<template>
  <v-row align="center" class="list px-3 mx-auto">
    <v-col cols="12" sm="12">
      <v-card class="mx-auto" tile>
        <v-card-title>
          <span class="mx-auto">Administración de Entidades</span>
        </v-card-title>
        <v-card-subtitle>
          <v-text-field  
            label="Filtrar por..."
            v-model="filtro"
          ></v-text-field>
        </v-card-subtitle>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="getEntidades"
            :search="filtro"
            disable-pagination
            :hide-default-footer="true"
          >
            <!-- <template v-slot:item.deCPNU="{ item }">
              <v-simple-checkbox v-model="item.deCPNU" color="green darken-3" />
            </template> -->

            <!-- <template v-slot:item.seguimientoConSnapShot="{item}">
              <v-checkbox 
                readonly
                v-model="item.seguimientoConSnapShot" 
                color="green darken-3" 
              />
            </template> -->
            <template v-slot:item.contacto="{item}">
              {{item.contactoNombres}} {{item.contactoApellidos}}
            </template>
            <template v-slot:item.seguimientoConSnapShot="{item}">
              <div>
                <v-checkbox 
                  readonly
                  v-model="item.seguimientoConSnapShot" 
                  color="green darken-3" 
                />
                <!-- <v-icon small @click="editarEntidad(item.idEntidad)" >fas fa-edit</v-icon>             -->
              </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon small class="mr-2" @click="editarEntidad(item.idEntidad)">fas fa-edit</v-icon>
            </template>          
          </v-data-table>
        </v-card-text>
        <!-- <v-card-actions v-if="tutorials.length > 0">
          <v-btn small color="error" @click="removeAllTutorials">
            Remove todo
          </v-btn>
        </v-card-actions> -->
        <v-card-actions>
            <!-- @click="agregarEntidad" -->
          <v-spacer></v-spacer>
          <v-btn
            :class="`${
              $vuetify.breakpoint.xs ? 'mt-4 ' : ' '
            } mx-2 font-weight-bold`"
            width="200"
            dark
            color="success"
            aria-label="Agregar Entidad"
            @click="agregarEntidad"
            >
            Agregar Entidad  
          </v-btn
          >          
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "MainAccesoEntidades",
  data: () => ({
    filtro:'',
    headers: [
      { text: "Entidad", align: "start", sortable: false, value: "entidad" },
      { text: "Dominio", value: "dominio", sortable: false },
      { text: "Observaciones", value: "observaciones", sortable: false },
      { text: "Contacto", value: "contacto", sortable: false },
      { text: "Cant. Usuarios", value: "cantidadUsuarios", sortable: false },
      { text: "Procesos x Usuario", value: "procesosPorUsuario", sortable: false },
      { text: "Con SnapShot", value: "seguimientoConSnapShot", sortable: false },
      { text: "Hora Ini", value: "horaIni", sortable: false },
      { text: "Hora Fin", value: "horaFin", sortable: false },
      { text: "Acciones", value: "actions", sortable: false, align: "center"},
    ],
  }),
  methods: {
    ...mapActions('acceso',['fetchEntidades']),
    agregarEntidad(){
      // this.$router.push({name:'MainAccesoEntidad', params: { id: -1} })
      this.$router.push({name:'MainAccesoEntidad'})
    },
    editarEntidad(id){
      // this.$router.push({name:'MainAccesoEntidad', params: { id: -1} })
      this.$router.push({name:'MainAccesoEntidad', params: {id: id}})
    }
  },
  computed: {
    ...mapGetters('acceso',['getEntidades'])  
  },
  created() {
    // this.$store.dispatch("acceso/fetchUsuarios");
    this.fetchEntidades()
  }
};
</script>
